import React from "react";
import { Image } from "@wss/image";

interface Props {
  resourcePath: string;
  caption: string;
}

const ReviewImage = ({ resourcePath, caption }: Props) => {
  return (
    <Image
      src={resourcePath}
      data-testid="product-review-modal-photo"
      alt={caption}
      className="bg-none w-full h-full object-contain"
      height={200}
      width={250}
      loading="lazy"
    />
  );
};

export default ReviewImage;
